export default __webpack_public_path__ + "static/media/ransomewareRealcase-en.bd71152e.png";